import { isShipmentStarted } from '../../../../../../../../helpers/entities/shipment/is-shipment-started'
import type { DataSourceItem } from '../../../../../../shipments-page'

export const useIsShipmentStarted = (shipment?: DataSourceItem) => {
    return isShipmentStarted(shipment)
}
